import styles from "../bussiness.module.css";
import { AiFillDelete } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import ReactTooltip from "react-tooltip";
const BoxClub = ({ item, index, customers, setSelectedItem }) => {
  const editHandler = () => {
    setSelectedItem(index);
    console.log(index);
    console.log("custom", customers[index]);
  };

  return (
    <div
      className={`  w-100  ${styles.sec}`}
      style={{
        borderRadius: " 10px",
      }}
    >
      <div className={`d-flex flex-wrap ${styles.secondry}`}>
        <div className={`${styles.BlueCol} ${styles.club}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            نوع
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.name}{" "}
          </p>
        </div>
        <div className={`${styles.BlueCol} ${styles.club}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            دسته بندی
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.mobile}{" "}
          </p>
        </div>
        <div className={`${styles.BlueCol} ${styles.club}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            لاین ها
          </p>
          <div
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.totalProduct}
          </div>
        </div>
        <div className={`${styles.BlueCol} ${styles.club}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            شهر
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.totalItem}
          </p>
        </div>
        <div className={`${styles.BlueCol} ${styles.club}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            کالا
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.price}
          </p>
        </div>

        <div className={`${styles.BlueCol} ${styles.club}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            عرضه کننده
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.price}
          </p>
        </div>
        <div className={`${styles.BlueCol} ${styles.club}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            سقف
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.price}
          </p>
        </div>
        <div className={`${styles.BlueCol} ${styles.club}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            عملیات{" "}
          </p>
          <div
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            <p
              className={styles.tlg}
              data-bs-toggle="modal"
              data-bs-target={`#exampleModalDelete`}
              onClick={editHandler}
            >
              <h4 data-tip="حذف">
                <AiFillDelete className={styles.tlg1} />
              </h4>
              <ReactTooltip />
            </p>
            <p
              className={styles.tlg}
              data-bs-toggle="modal"
              data-bs-target={`#exampleModalEdit`}
              onClick={editHandler}
            >
              <h4 data-tip="ویرایش">
                <FiEdit className={styles.tlg1} />
              </h4>
              <ReactTooltip />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoxClub;
